import React, { useState } from "react";
import "../../Styles/AnnadataSukhibhavaForm.css";

const AdminAnnadataSukhibhavaForm = () => {
  const [formData, setFormData] = useState({
    farmerName: "",
    relation: "",
    landExtent: "",
    surveyNumber: "",
    voterId:"",
    aadhaar: "",
    mobile: "",
    bankAccount: "",
    ifsc: "",
    amount: "20000",
    village: "",
    mandal: "",
    date: "",
    status: "",
    remarks: "",
    photo: null,
    document: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setFormData({
      ...formData,
      [name]: files ? files[0] : value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(formData);
  };

  return (
    <div className="annadata-form-container">
      <div className="annadata-form-card">
        <div className="annadata-form-header">
          <h2>Add New Annadata Sukhibhava Beneficiary</h2>
          <p>₹20,000 annual financial assistance for eligible farmers</p>
          <button
            className="annadata-back-btn"
            onClick={() => window.history.back()}
          >
            Back
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="annadata-form-grid">

            <div className="annadata-form-group">
              <label>Farmer Name *</label>
              <input
                type="text"
                name="farmerName"
                placeholder="Enter Farmer Name"
                onChange={handleChange}
              />
            </div>

            <div className="annadata-form-group">
              <label>Relation *</label>
              <input
                type="text"
                name="relation"
                placeholder="Ex: S/O, W/O"
                onChange={handleChange}
              />
            </div>

            <div className="annadata-form-group">
              <label>Land Extent (Acres) *</label>
              <input
                type="number"
                step="0.01"
                name="landExtent"
                placeholder="Enter Land Extent"
                onChange={handleChange}
              />
            </div>

            <div className="annadata-form-group">
              <label>Survey Number *</label>
              <input
                type="text"
                name="surveyNumber"
                placeholder="Enter Survey Number"
                onChange={handleChange}
              />
            </div>
             <div className="annadata-form-group">
              <label>Voter Id *</label>
              <input
                type="text"
                name="voterId"
                placeholder="Enter voter Id"
                maxLength="12"
                onChange={handleChange}
              />
            </div>

            <div className="annadata-form-group">
              <label>Aadhaar Number *</label>
              <input
                type="text"
                name="aadhaar"
                placeholder="Enter 12-digit Aadhaar Number"
                maxLength="12"
                onChange={handleChange}
              />
            </div>

            <div className="annadata-form-group">
              <label>Mobile Number *</label>
              <input
                type="tel"
                name="mobile"
                placeholder="Enter Mobile Number"
                maxLength="10"
                onChange={handleChange}
              />
            </div>

            <div className="annadata-form-group">
              <label>Bank Account Number *</label>
              <input
                type="text"
                name="bankAccount"
                placeholder="Enter Bank Account Number"
                onChange={handleChange}
              />
            </div>

            <div className="annadata-form-group">
              <label>IFSC Code *</label>
              <input
                type="text"
                name="ifsc"
                placeholder="Enter IFSC Code"
                onChange={handleChange}
              />
            </div>

            <div className="annadata-form-group">
              <label>Annual Amount (₹) *</label>
              <input
                type="number"
                name="amount"
                value={formData.amount}
                readOnly
                onChange={handleChange}
              />
            </div>

            <div className="annadata-form-group">
              <label>Village *</label>
              <input
                type="text"
                name="village"
                placeholder="Enter Village"
                onChange={handleChange}
              />
            </div>

            <div className="annadata-form-group">
              <label>Mandal *</label>
              <select name="mandal" onChange={handleChange}>
                <option>Select Mandal</option>
                <option>Kandukur</option>
                <option>Gudluru</option>
                <option>Ulavapadu</option>
              </select>
            </div>

            <div className="annadata-form-group">
              <label>Date *</label>
              <input
                type="date"
                name="date"
                onChange={handleChange}
              />
            </div>

            <div className="annadata-form-group">
              <label>Status *</label>
              <select name="status" onChange={handleChange}>
                <option>Select Status</option>
                <option>Approved</option>
                <option>Pending</option>
              </select>
            </div>

            <div className="annadata-form-group">
              <label>Upload Photo *</label>
              <input
                type="file"
                name="photo"
                accept="image/*"
                onChange={handleChange}
              />
            </div>

            <div className="annadata-form-group">
              <label>Upload Supporting Document</label>
              <input
                type="file"
                name="document"
                accept=".pdf,image/*"
                onChange={handleChange}
              />
            </div>

          </div>

          <div className="annadata-form-group annadata-full-width">
            <label>Remarks</label>
            <textarea
              rows="4"
              name="remarks"
              placeholder="Enter Remarks"
              onChange={handleChange}
            ></textarea>
          </div>

          <div className="annadata-btn-group">
            <button type="submit" className="annadata-submit-btn">
              Submit
            </button>
            <button type="reset" className="annadata-reset-btn">
              Reset
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminAnnadataSukhibhavaForm;